import { createFileRoute, notFound } from "@tanstack/react-router";
import { LegalView } from "@/components/pages/LegalView";
import { privacy } from "@/content/legal";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/privacy")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/privacy",
          ...meta[params.locale].privacy,
        })
      : {},
  component: PrivacyRoute,
});

function PrivacyRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LegalView locale={locale} doc={privacy[locale]} />;
}
